module.exports = __webpack_public_path__ + "r-v3/img/sticker_8_icon.52140800.svg";